// extracted by mini-css-extract-plugin
export const stickyHeader = "StickyHeader__stickyHeader__iacZl";
export const maxWidth = "StickyHeader__maxWidth__Wpo8t";
export const noAnimation = "StickyHeader__noAnimation__G3swT";
export const isSticked = "StickyHeader__isSticked__RmSla";